import { Site } from '@cinch-labs/sites-sdk'
import { getSites } from '@cinch-nx/shared-sites'
import { GetStaticPathsResult } from 'next/types'

const WBAC_SLUG_PREFIX = /^wbac-/i

const normaliseSlug = (slug: string): string =>
  slug.replace(WBAC_SLUG_PREFIX, '').trim().toLowerCase()

const getSlugFromSite = (site: Site): string | undefined => {
  const slug = site.getFeatureAttribute('slug')

  if (slug === undefined) return

  return normaliseSlug(slug)
}

export const getStaticPaths = async (): Promise<GetStaticPathsResult> => {
  try {
    const sites = await getSites({ tags: ['webuyanycar'] })
    const uniqueSlugs = new Set<string>()

    for (const site of sites) {
      const slug = getSlugFromSite(site)

      if (slug) {
        uniqueSlugs.add(slug)
      }
    }

    const paths = [...uniqueSlugs].map((slug) => ({ params: { slug } }))

    return { paths, fallback: 'blocking' }
  } catch (error) {
    throw new Error(
      `getStaticPaths: failed to fetch WBAC collection sites: ${
        error instanceof Error ? error.message : String(error)
      }`,
    )
  }
}
